import request from "@/utils/request";
import service from "@/utils/axios-v2";

export function getCompany(token) {
  return service({
    url: "/fleet/company/info",
    headers: {
      "portal-token": token || true
    }
  });
}

export function updateCompany(data) {
  return request({
    url: "/fleet/company/info/edit",
    method: "put",
    data,
    headers: {
      "portal-token": true
    }
  });
}
